import React from 'react';
import { Outlet } from 'react-router-dom';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import hooks
import { useRouteInfo } from 'js/hooks/useRouteInfo';

// import containers
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';

// import components
import TransitionPage from 'js/containers/transition/Transition.page.jsx';
import { setScreenName } from '../utils/tracking';

const PageCollections = () => {
  const { displayOtherButtons = false } = useRouteInfo().state || {};

  React.useEffect(() => {
    setScreenName('Collections');
  }, []);

  React.useEffect(() => {
    setBodyBackgroudColor(displayOtherButtons ? '#F7EBB1' : '#BBDCD5');
  }, [displayOtherButtons]);

  return (
    <TransitionPage>
      <SectionPageWrapper className={'page--collections'} bgColor={displayOtherButtons ? '#F7EBB1' : '#BBDCD5'}>
        <Outlet />
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageCollections;
